/**
 * API DOC: https://apiv4.stagebt.sharkscode.com/api/doc/seo#/Public%20seo/SeoPublicController_getSeoPage
* */
import * as localCache from '@/services/simpleCache'
import useUrl from './helpers/useUrl'
import { mergeUrlWithParams, cacheRequest } from './helpers/seo'

export default (client , { apiUrl, apiUrlV2 }) => {
  const root = useUrl(`${apiUrl}/seo`)
  const rootV2 = useUrl(`${apiUrlV2}/seo`)

  return {
    async getSeo(path) {
      const url = root('public/page')
      const queryParams = {
        url: path,
      }
      return client.get(url, { params: queryParams })
    },

    partnerBanners({ query }) {
      const url = rootV2(`refcode_promotions${query}`)

      return client.get(url)
    },
  }
}
